module.exports = __webpack_public_path__ + "img/1455271348.cf0bfd19.jpg";